import React, { useState, useRef, useEffect } from 'react';
// import './TabSwitcher.css';
import '../../styles/TabSwitcher.scss';
import OnChainTab from './onchain';
import OffChainTab from './offchain';
import FooterTab from './pgs_footer';
import { useNavigate, Link } from 'react-router-dom';


function TabSwitcher() {
  const [activeTab, setActiveTab] = useState('OnChain');
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

const [showDropdown, setShowDropdown] = useState(false);
const [settingDropdown, setSettingDropdown] = useState(false);
const dropdownContainerRef = useRef(null);
const settingDropdownContainerRef = useRef(null);

const handleDropdownClick = () => {
  setShowDropdown(!showDropdown);
};

const handleSettingDropdownClick = () => {
  setSettingDropdown(!settingDropdown);
};

useEffect(() => {
  setIsLoading(true);
  const handleClickOutside = (event) => {
    if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
      setShowDropdown(false);
      // setSettingDropdown(false);
    }
  };
  const handleSettingClickOutside = (event) => {
    if (settingDropdownContainerRef.current && !settingDropdownContainerRef.current.contains(event.target)) {
      setSettingDropdown(false);
    }
  };
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('click', handleSettingClickOutside);
  return () => {
    document.removeEventListener('click', handleClickOutside);
    document.removeEventListener('click', handleSettingClickOutside);
  };
}, []);


if (isLoading) {
  return (
    <div className="tab-switcher-container">
        <nav className="head-tab-container">
          <div className='navbar-brand-img'>
          <div className='navbar-brand-img'>
           <img src='/data/staking/navbar-brand.png' />
          </div>

        </div>
        <div className="page-tab-container">
          <a className={`page-tab-item ${activeTab === 'OnChain'? 'pgs-head-active': 'title-card-inactive'}`} onClick={() => handleTabClick('OnChain')}>On-chain Faucet</a>
          <a className={`page-offchain-tab-item ${activeTab === 'OffChain'? 'pgs-head-active': 'title-card-inactive'}`} onClick={() => handleTabClick('OffChain')}>Off-chain Faucet</a>
          {/* <a className="api-service-tab-item">Advanced APIs{`\u00A0`}<p className='coming-coon-item'>Coming Soon !</p></a> */}
        </div>
        <div className='document-title-card'>
        <a href="https://github.com/DoraFactory/DI-QRNG-Faucet" className="stake-amount-date-container" target="_blank">
        <div className='logo-container'>
          Documentation 
        </div>
        <img src='/data/staking/public-good-staking-btn-right-sm.png'/>
        </a>
        </div>
      </nav>


        <div className='tab-switcher-card'>
        {/* <div className="tab-nav">




          <div
            className={`tab-item ${activeTab === 'Stats' ? 'active' : ''}`}
            onClick={() => handleTabClick('Stats')}
          >
                    {
          activeTab === 'Stats'?
          <img src='/data/staking/icon-stats-switch.png'/>
          :
          <img src='/data/staking/icon-stats.png'/>
        }
            <div className='tab-item-name'>Stats</div>
          </div>

          <div
            className={`tab-item ${activeTab === 'Addresses' ? 'active' : ''}`}
            onClick={() => handleTabClick('Addresses')}
          >
                      {
          activeTab === 'Addresses' ?
          <img src='/data/staking/icon-addresses-switch.png'/>
          :
          <img src='/data/staking/icon-addresses.png'/>
        }
          <div className='tab-item-name'>Addresses</div>
          </div>


          <div
            className={`tab-item ${activeTab === 'Incentives' ? 'active' : ''}`}
            onClick={() => handleTabClick('Incentives')}
          >
                      {
          activeTab === 'Incentives' ?
          <img src='/data/staking/icon-incentives-switch.png'/>
          :
          <img src='/data/staking/icon-incentives.png'/>
        }
          <div className='tab-item-name'>Incentives</div>
          </div>
        </div> */}
        <div className="tab-content">
          {/* {activeTab === 'Stats' ? <StatsTab /> : <AddressesTab />}
           */}
               <div>
      {/* {activeTab === 'Stats' && <StatsTab setActiveTab={setActiveTab} />}
      {activeTab === 'Addresses' && <AddressesTab setActiveTab={setActiveTab} />} */}
      {activeTab === 'OnChain' && <OnChainTab/>}
      {activeTab === 'OffChain' && <OffChainTab/>}
    </div>
        </div>
      </div>
      <FooterTab/>
    </div>
    );
  }
}

export default TabSwitcher;
